import { httpStatusCode } from '@netpurpose/utils'
import { ApiError } from '../../../errors'

export const emptyOnNotFound = async <T>(request: (() => Promise<T>) | null) => {
  if (!request) {
    return null
  }

  try {
    return await request()
  } catch (error) {
    if (error instanceof ApiError && error.status === httpStatusCode.notFound) {
      return null
    }
    throw error
  }
}
